<template>
  <div>
    <AppPageHeader title="Settings" />

    <AppTabs :items="tabItems" :default-index="selectedIndex">
      <template #content="">
        <router-view :key="$route.fullPath" />
      </template>
    </AppTabs>
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'
import AppPageHeader from '@/components/app/AppPageHeader.vue'
import AppTabs, {TabItem} from '@/components/app/AppTabs.vue'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'

useHead({
  title: 'Settings'
})
const $route = useRoute()
const tabItems: TabItem[] = [
  { label: 'General Setting', to: { name: 'GeneralSettings' } },
  { label: 'Email Setting', to: { name: 'EmailSettings' } },
  { label: 'User Setting', to: { name: 'UserSettings' } },
  // { label: 'Hubspot Setting', to: { name: 'HubspotSettings' } },
  { label: 'QuickBooks Setting', to: { name: 'QuickBooksSettings' } },
]


const router = useRouter()
const selectedIndex = computed(() => {
  const index = tabItems.findIndex(tab => {
    if (router.resolve(tab.to).path === router.currentRoute.value.path) {
      return true
    } else {
      if (router.currentRoute.value.name === 'EditUser') {
        return tab.label === 'User Setting'
      }
    }
  })
  return index === -1 ? 0 : index
})
</script>
